import SedeLocation from '../../components/register/SedeLocation';
import React, { useState, useCallback } from 'react';
import { MapPin, Navigation, CheckCircle, Map } from 'lucide-react';

const UbiPublish = ({ 
  formData, 
  setFormData,
  searchBoxRef 
}) => {
  const handleLocationSelect = (locationData) => {
    setFormData(prev => ({
      ...prev,
      mapa_direccion: locationData.formatted_address, // Dirección completa para el input
      ubicacion: locationData.simplified_address, // Dirección simplificada para mostrar
      latitude: locationData.lat,
      longitude: locationData.lng
    }));
  };

  return (
    <div className="space-y-8">
      {/* Header mejorado */}
      <div className="text-center mb-8">
        <div className="relative mb-6">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-0.5 w-12 bg-gradient-to-r from-transparent to-red-500 rounded-full"></div>
            <div className="p-3 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl shadow-lg">
              <MapPin className="w-6 h-6 text-white" />
            </div>
            <div className="h-0.5 w-12 bg-gradient-to-l from-transparent to-pink-500 rounded-full"></div>
          </div>
          
          <h2 className="text-3xl font-bold bg-gradient-to-r from-red-600 via-pink-600 to-purple-600 
                         bg-clip-text text-transparent mb-3">
            Ubicación de la Propiedad
          </h2>
          
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></div>
            <div className="w-16 h-0.5 bg-gradient-to-r from-red-400 to-pink-400 rounded-full"></div>
            <div className="w-2 h-2 bg-pink-400 rounded-full animate-pulse delay-75"></div>
          </div>
        </div>
        
        <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed">
          Busca y selecciona la ubicación exacta de tu propiedad en el mapa
        </p>
      </div>

      {/* Contenedor principal del mapa */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
        <div className="flex items-center gap-3 p-6 bg-gradient-to-r from-red-50 to-pink-50 border-b border-gray-100">
          <div className="p-2 bg-gradient-to-br from-red-100 to-red-200 rounded-xl">
            <Map className="h-6 w-6 text-red-600" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-800">Selector de Ubicación</h3>
            <p className="text-gray-500 text-sm">Busca la dirección o haz clic en el mapa para marcar la ubicación</p>
          </div>
        </div>

        {/* Componente del mapa */}
        <div className="p-6">
          <SedeLocation 
            location={{
              direccion_sede: formData.mapa_direccion,
              lat_sede: formData.latitude,
              lng_sede: formData.longitude
            }}
            onLocationSelect={handleLocationSelect}
          />
        </div>
      </div>

      {/* Información de ubicación seleccionada */}
      {formData.ubicacion && (
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-2xl p-6 shadow-lg">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-gradient-to-br from-green-100 to-green-200 rounded-xl">
              <CheckCircle className="h-6 w-6 text-green-600" />
            </div>
            <div className="flex-1">
              <h4 className="text-lg font-bold text-green-800 mb-2">Ubicación Confirmada</h4>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <Navigation className="h-4 w-4 text-green-600" />
                  <span className="text-green-700 font-medium">Dirección seleccionada:</span>
                </div>
                <p className="text-green-800 bg-green-100 px-4 py-2 rounded-xl font-medium">
                  {formData.ubicacion}
                </p>
                {formData.latitude && formData.longitude && (
                  <div className="flex items-center gap-4 text-sm text-green-600 mt-3">
                    <span className="bg-green-100 px-3 py-1 rounded-full">
                      <strong>Lat:</strong> {Number(formData.latitude).toFixed(6)}
                    </span>
                    <span className="bg-green-100 px-3 py-1 rounded-full">
                      <strong>Lng:</strong> {Number(formData.longitude).toFixed(6)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Instrucciones de uso */}
      {!formData.ubicacion && (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-6">
          <div className="flex items-start gap-4">
            <div className="p-2 bg-blue-100 rounded-xl">
              <MapPin className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-blue-800 mb-2">¿Cómo seleccionar la ubicación?</h4>
              <ul className="space-y-2 text-blue-700">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>Escribe la dirección en el campo de búsqueda</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>Haz clic directamente en el mapa donde está tu propiedad</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>Arrastra el marcador para ajustar la posición exacta</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UbiPublish;